import { render, staticRenderFns } from "./MapIconTrcOkeaniya.vue?vue&type=template&id=53320e4b&scoped=true&"
import script from "./MapIconTrcOkeaniya.vue?vue&type=script&lang=js&"
export * from "./MapIconTrcOkeaniya.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53320e4b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53320e4b')) {
      api.createRecord('53320e4b', component.options)
    } else {
      api.reload('53320e4b', component.options)
    }
    module.hot.accept("./MapIconTrcOkeaniya.vue?vue&type=template&id=53320e4b&scoped=true&", function () {
      api.rerender('53320e4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/map/icons/MapIconTrcOkeaniya.vue"
export default component.exports